import axios from 'axios';
import config from 'config';
import { createApi } from 'utils/api';

const salesOrderV1Api = axios.create({
  baseURL: config.salesOrderV1ApiBaseUrl,
  params: {
    apikey: config.apiKey,
  },
});

const createSalesOrderV1Api = createApi(salesOrderV1Api);
export const getSalesOrderV1Data = createSalesOrderV1Api('get');
export const patchSalesOrderV1Data = createSalesOrderV1Api('patch');
export const postSalesOrderV1Data = createSalesOrderV1Api('post');
export const putSalesOrderV1Data = createSalesOrderV1Api('put');